export default __webpack_public_path__ + "static/media/Chestguard of the Assailant.acf1bb3a.jpg";